import { BackSide, DoubleSide, FrontSide } from 'three';

export const sideValues = {
    FrontSide,
    BackSide,
    DoubleSide,
};

export const sideNames: { [v: number]: Side } = {};
Object.keys(sideValues).forEach((k: Side) =>
{
    sideNames[sideValues[k]] = k;
});

export type Side = keyof typeof sideValues;
